import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import 'react-table/react-table.css';
import { getNoteGroupDropDown, getFieldNoteById, getNoteDocument } from '../../actions/resources/NoteActions';
import DatePickerForFilter from '../../utils/DatePickerForFilter';
import { getNoteReport, setInitialState } from '../../actions/reports/ReportsActions';
import i18n from '../../i18n/i18n';
import Select from 'react-select';
import immutable from 'seamless-immutable';
import { Fab } from '@material-ui/core';
import { exportDocument } from '../../actions/ExportActions';
import Export from '../../utils/Export';
import DashboardDrawer from '../../utils/DashboardDrawer';
import { getUser } from '../../utils/CommonFunctions';
import AddNote from './AddNote';
const CheckboxTable = checkboxHOC(ReactTable);;

export class Note extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showFilters: false,
            selection: [],
            selectAll: false,
            add: false,
            edit: false,
            user: {}
        };
        this.tableScrollTop = 0;
    }

    componentDidMount() {
        this.setState({ user: getUser() })
        if (this.props.noteGroupDropDown.length === 0) {
            this.props.getNoteGroupDropDown();
        }
    }

    componentDidUpdate(prevProps) {
        const { notesPostingSuccess, noteGroupDropDown } = this.props;
        const { user } = this.state;
        if (prevProps.notesPostingSuccess === false && notesPostingSuccess === true) {
            this.setState({
                selection: [],
                name: '',
                selectAll: false
            })
            this.handleClick();
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getNoteReport(wrapped.state);
            this.props.setInitialState('notesPostingSuccess');
        }
        if (prevProps.noteGroupDropDown !== noteGroupDropDown) {
            this.setState({
                noteGroupDropDown: immutable.asMutable(noteGroupDropDown.map((item) => { return { label: user.id_region === 2 && item.naziv || item.naziv_en, value: item.id } }), { deep: true }),
            })
        }

    }

    handleClick = () => {
        if (this.state.edit == true && this.state.add == false) {
            this.setState({ edit: false })
            this.props.setInitialState('notesObj');
        } else if (this.state.selection.length > 0 && this.state.add == false && this.state.edit == false) {
            this.props.setInitialState('notesObj');
        }
        this.setState({ add: !this.state.add }, () => {
            if (this.state.add == true && this.state.edit == false) {
                this.setState({
                    selection: [],
                    selectAll: false,
                })
            }
        });
    };

    onEditClick = () => {
        const { getFieldNoteById, getNoteDocument } = this.props;
        const { selection } = this.state;
        getFieldNoteById(selection);
        this.setState({ add: !this.state.add, edit: true }, () => {
            getNoteDocument(selection)
        });
    }

    onSearchClick() {
        this.setState({ showFilters: !this.state.showFilters });
    }

    onExportClick = () => {
        this.setState({ export: !this.state.export });
    }

    exportFunction = () => {
        const table = this.checkboxTable.getWrappedInstance();
        this.props.exportDocument(this.state.docTitle, table.state, 'api/report/field_note');
        this.setState({ export: !this.state.export });
    }

    onPieClick = () => {
        this.props.history.push('/notes_dashboard');
    }

    onTableClick = () => {
        this.props.history.push('/notes');
    }

    toggleSelection = (key, shift, row) => {
        let selection = [...this.state.selection];
        const keyIndex = selection.indexOf(key);
        if (keyIndex >= 0) {
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
        } else {
            selection.push(key);
        }
        this.setState({ selection });
    };

    toggleAll = () => {
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        if (selectAll) {
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => {
                selection.push(item._original.id);
            });
        }
        this.setState({ selectAll, selection });
    };

    isSelected = key => {
        return this.state.selection.includes(key);
    };




    render() {
        const { selectAll, add, edit, user } = this.state;
        const columns = [
            {
                Header: i18n.t('Title'),
                accessor: 'naslov',
            },
            {
                Header: i18n.t('Date of the event'),
                accessor: 'datum_dogadjaja',
                Filter: ({ filter, onChange }) =>
                    <DatePickerForFilter
                        onChange={({ startDate, endDate }) => {
                            onChange({ startDate, endDate });
                        }}

                    />
            },
            {
                Header: i18n.t('Notes type'),
                accessor: user.id_region == 2 && 'naziv' || 'naziv_en',
                Filter: ({ filter, onChange }) =>
                    <Select
                        isMulti
                        name="naziv"
                        onChange={value => {
                            onChange(value)
                        }}
                        closeMenuOnSelect={false}
                        options={this.state.noteGroupDropDown}
                        className="multi-select-in-filter"
                        classNamePrefix="select"
                        placeholder={i18n.t('Select')}
                    />

            },
            {
                Header: i18n.t('Name'),
                accessor: 'ime',
            },
            {
                Header: i18n.t('Surname'),
                accessor: 'prezime',
            },
            {
                Header: i18n.t('Description'),
                accessor: 'opis',
            }

        ];
        const { toggleSelection, toggleAll, isSelected, handleClick } = this;
        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return {
                        style: {
                            backgroundColor: selected ? "lightgreen" : "inherit"
                        }
                    };
                }
                return {};
            }
        };
        return (
            <div className="page">
                <div className="table-header">
                    <Fab
                        onClick={() => this.handleClick()}
                        color="primary"
                        aria-label="add"
                        className="action-button"
                    >
                        <span className="icon-Plus headerIcon" />
                    </Fab>
                    <Fab
                        onClick={() => this.onSearchClick()}
                        color="primary"
                        aria-label="add"
                        className="action-button"
                    >
                        <span className="icon-search headerIcon" />
                    </Fab>
                    <Fab
                        onClick={() => this.onExportClick()}
                        color="primary"
                        aria-label="add"
                        className="action-button"
                    >
                        <span className="icon-download headerIcon" />
                    </Fab>
                    {this.state.selection.length === 1 ?
                        <Fab
                            onClick={() => this.onEditClick()}
                            color="primary"
                            aria-label="edit"
                            className="action-button"
                        >
                            <span className=" icon-Informacija headerIcon" />
                        </Fab>
                        : null
                    }
                </div>
                <CheckboxTable
                    data={this.props.noteReport}
                    ref={r => (this.checkboxTable = r)}
                    getTheadFilterThProps={() => { return { style: { position: "inherit", overflow: "inherit" } } }}
                    columns={columns}
                    keyField={'id'}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={25}
                    filterable={this.state.showFilters}
                    pages={this.props.noteReportPages}
                    loading={this.props.noteReportFetching}
                    manual
                    showPaginationTop
                    showPaginationBottom={false}
                    onFetchData={(state, instance) => this.props.getNoteReport(state, instance)}
                    className="-striped -highlight table-drawer"
                    previousText={i18n.t('Previous')}
                    nextText={i18n.t('Next')}
                    loadingText={i18n.t('Loading...')}
                    noDataText={i18n.t('No rows found')}
                    pageText={i18n.t('Page')}
                    ofText={i18n.t('of')}
                    rowsText={i18n.t('rows')}
                    {...checkboxProps}
                />
                {add && <AddNote add={add} handleClose={handleClick} edit={edit} />}
                <DashboardDrawer onPieClick={this.onPieClick} onTableClick={this.onTableClick} />
                {this.state.export && <Export
                    export={this.state.export}
                    onTextChange={({ title }) => {
                        this.setState({ docTitle: title });
                    }}
                    handleClose={this.onExportClick}
                    exportDoc={this.exportFunction} />
                }
            </div>
        )
    }
};

function mapStateToProps(state) {
    return {
        noteReport: state.reportsReducer.noteReport,
        noteReportFetching: state.reportsReducer.noteReportFetching,
        noteReportPages: state.reportsReducer.noteReportPages,
        noteGroupDropDown: state.noteReducer.noteGroupDropDown,
        noteGroupDropDownFetching: state.noteReducer.noteGroupDropDownFetching,
        noteGroupDropDownFetchingFailed: state.noteReducer.noteGroupDropDownFetchingFailed,
        notesPostingSuccess: state.reportsReducer.notesPostingSuccess
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getNoteReport: (state, instance) => dispatch(getNoteReport(state, instance)),
        getNoteGroupDropDown: () => dispatch(getNoteGroupDropDown()),
        exportDocument: (title, state, url) => dispatch(exportDocument(title, state, url)),
        setInitialState: (component) => dispatch(setInitialState(component)),
        getFieldNoteById: (id) => dispatch(getFieldNoteById(id)),
        getNoteDocument: (id) => dispatch(getNoteDocument(id))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Note);